// extracted by css-extract-rspack-plugin
var _1 = "BuopEOAf0R8DJS5C";
var _2 = "oQVzAgt_GeICdVtU";
export { _1 as "inputBase", _2 as "inputBaseDisabled" }
// extracted by css-extract-rspack-plugin
var _1 = "BuopEOAf0R8DJS5C";
var _2 = "oQVzAgt_GeICdVtU";
export { _1 as "inputBase", _2 as "inputBaseDisabled" }
